import React from 'react';

import PropTypes from 'prop-types';

import Button from '@asteria/component-core/button';
import { Text, TextGroup } from '@asteria/component-core/typography';

// import Contenter from '@asteria/component-tools/contenter';
import { FeatureFlag } from '@asteria/component-tools/featureflag';

import { Translation } from '@asteria/language';
import { useTranslationFn } from '@asteria/language/hooks';
import { cn } from '@asteria/utils-funcs/classes';

// import useConfig from '@asteria/utils-hooks/useConfig';
import './styles.scss';

const footerLinkGroups = [
	{
		key: 'type-merged',
		links: [
			'type-cookie',
			'type-data-processing',
			'type-privacy',
			'type-linkedin',
			'type-documentation',
			'type-api',
		],
	},
];

const Footer = React.memo(function Footer(props) {
	const { onAction } = props;
	const translate = useTranslationFn();

	// const content = useConfig('pages.auth.footer.config', { deep: true });

	// const actions = React.useMemo(() => ({ onAction }), [onAction]);

	return (
		<FeatureFlag feature="auth-footer">
			<div
				className={cn(
					'py-8 px-2 md:px-20',
					'asteria-component__auth-footer',
				)}
			>
				<div
					className={cn(
						'flex flex-col-reverse md:flex-row flex-1 justify-between gap-4',
						'asteria-component__auth-footer-content',
					)}
				>
					<div className="flex gap-4">
						{/* <Contenter content={content} actions={actions} /> */}

						<TextGroup className="flex flex-col gap-1 px-2 md:px-0">
							<Translation
								translationKey="login.footer.title"
								Component={Text}
								size="md"
								weight="medium"
							/>
							<Translation
								translationKey="login.footer.copyright"
								Component={Text}
								size="sm"
							/>
						</TextGroup>
					</div>
					<div className={cn('asteria-component__auth-footer-links')}>
						{footerLinkGroups.map((group) => (
							<div
								key={group.key}
								className={cn(
									'flex flex-col gap-2 xl:flex-row',
									'asteria-component__auth-footer-links-group',
								)}
							>
								{group.header ? (
									<Text weight="bold" size="lg">
										{group.header}
									</Text>
								) : null}
								{group.links.map((linkKey) => (
									<Button
										key={linkKey}
										size="sm"
										variant="flat"
										href={translate(
											`login.footer.link.${linkKey}.path`,
										)}
										label={translate(
											`login.footer.link.${linkKey}.label`,
										)}
										target="_blank"
									/>
								))}
							</div>
						))}
					</div>
				</div>
			</div>
		</FeatureFlag>
	);
});

Footer.displayName = 'Footer';

Footer.propTypes = {
	onAction: PropTypes.func,
};

export default Footer;
